import { I18n } from 'aws-amplify'
import { object, string, number, date } from 'yup'

export const FIELDS = {
  id: 'id',
  organizationId: 'organizationId',
  packageUnitInventoryId: 'packageUnitInventoryId',
  fromStorageFacilityId: 'fromStorageFacilityId',
  shippingMethodId: 'shippingMethodId',
  storageFacilityId: 'storageFacilityId',
  packageUnitId: 'packageUnitId',
  status: 'status',
  quantity: 'quantity',
  shippedDate: 'shippedDate',
  deliveredDate: 'deliveredDate'
}

export const SCHEMA = () => {
  return object().shape({
    organizationId: string().required(I18n.get('An organization is required.')),
    packageUnitInventoryId: string().required(
      I18n.get('Please select the origin inventory.')
    ),
    shippingMethodId: string().required(
      I18n.get('Please select an origin shipping method.')
    ),
    storageFacilityId: string().required(
      I18n.get('Please select a destination storage facility.')
    ),
    status: string().required(I18n.get('Please select a status.')),
    quantity: number()
      .integer(I18n.get('A partial quantity is not allowed.'))
      .typeError(I18n.get('Quantity is required.'))
      .min(1, I18n.get('Quantity cannot be less than one.'))
      .required(I18n.get('Quantity is required.')),
    shippedDate: date()
      .nullable()
      .default(null)
      .typeError(I18n.get('Shipped date is invalid.'))
      .max(
        new Date(),
        I18n.get('The shipped date cannot be set in the future.')
      ),
    deliveredDate: date()
      .nullable()
      .default(null)
      .typeError(I18n.get('Delivered date is invalid.'))
      .max(
        new Date(),
        I18n.get('The delivered date cannot be set in the future.')
      )
  })
}
